import { createNode, el, resolve } from '@elemaudio/core'
import CompositeProps from '../types/CompositeProps'
import { SerializableDrumStem } from '../utils/CreateGraph'
import { treeAdd } from '../utils/ElementaryUtils'
import { createDrumEventMap } from '../utils/EventMapUtils'

export type DrumSamplerProps = {
  key: string
  stem: SerializableDrumStem
  sampleMap: string[]
  ppqn: number
  channel: number
  repeat: any
}

function prepareSequences(key: string, eventMap: any, ppqn: number, baseClock, resetClock, repeat) {
  // Loops
  let sequenceMap = eventMap.map((events: any, index) => {
    return el.sparseq(
      {
        key: `seq:subLoop${index}-${key}`,
        seq: events,
        offset: ppqn,
        loop: repeat.repeatSection ? [repeat.repeatStart, repeat.repeatEnd] : false
      },
      baseClock,
      resetClock
    )
  })
  return sequenceMap.filter(Boolean)
}

function DrumSamplerComposite({ props, children: [baseClock, resetClock] }: CompositeProps) {
  const { sampleMap, ppqn, key, stem, channel, repeat } = props

  // stem to drum trigger events
  const eventMap = createDrumEventMap(stem)
  // Create the multi-sequence map
  const sequenceMap = prepareSequences(key, eventMap, ppqn, baseClock, resetClock, repeat)

  if (sequenceMap.length === 0) sequenceMap.push(0)

  const drumVoices = sampleMap.map(function (_, i) {
    const path = `${sampleMap[i]}:${channel}`
    const sampleSequence = sequenceMap[i] ? sequenceMap[i] : 0
    const voiceKey = `drumsampler:${path}-${i}-${key}`
    const velocity = el.const({
      key: `${voiceKey}-velocity`,
      value: stem.drumGains[i]
    })
    return el.mul(
      el.sample(
        {
          key: `${voiceKey}-sample`,
          mode: 'trigger',
          path
        },
        sampleSequence,
        1
      ),
      el.smooth(el.tau2pole(0.32), velocity)
    )
  })

  return resolve(treeAdd(drumVoices))
}

export default function DrumSampler(props: DrumSamplerProps, baseClock, resetClock) {
  return createNode(DrumSamplerComposite, props, [baseClock, resetClock])
}
